import React, { type PropsWithChildren, startTransition, useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { type Language } from '@pkgs/api/index';

import { getShopFromQueryCache } from '@/utils/getShopFromQueryCache';
import { useExposePageProps } from '@/hooks/useExposePageProps';
import { useExposeLanguageStore } from '@/hooks/useExposeLanguageStore';
import { useListing } from '@/hooks/queries/useListing';
import { Layout } from '@/components/common/Layout/Layout';

export const ExposeLayout = ({ children }: PropsWithChildren) => {
  const queryClient = useQueryClient();
  const { countryLinks, spearHeadNavigation, pageLanguages } = useExposePageProps();
  const {
    data: { listing, genericListing },
  } = useListing();

  const shop = getShopFromQueryCache({ queryClient, listing });

  const setExposeLanguage = useExposeLanguageStore((state) => state.setExposeLanguage);

  const handleLanguageChange = useCallback(
    (headerLanguage: string) => {
      if (!listing) return;
      if (listing.languages?.includes(headerLanguage as Language)) {
        startTransition(() => {
          setExposeLanguage(headerLanguage as Language);
        });
      }
    },
    [listing, setExposeLanguage],
  );

  return (
    <Layout
      countryLinks={countryLinks}
      spearHeadNavigation={spearHeadNavigation}
      pageLanguages={pageLanguages}
      onLanguageChange={handleLanguageChange}
      listing={genericListing}
      shop={shop}
    >
      <main>{children}</main>
    </Layout>
  );
};
